import React from 'react'
import SalesStatisticOne from './child/SalesStatisticOne';
import TotalSubscriberOne from './child/TotalSubscriberOne';
import UsersOverviewOne from './child/UsersOverviewOne';
import LatestRegisteredOne from './child/LatestRegisteredOne';
import TopPerformerOne from './child/TopPerformerOne';
import TopCountries from './child/TopCountries';
import GeneratedContent from './child/GeneratedContent';
import UnitCountOne from './child/UnitCountOne';
import RegisteredUsersApexChart from "./chart/RegisteredUsersApexChart";
import WagerWeightedWagerChart from "./chart/WagerWeightedWagerChart";
import PackdrawWagerChart from "./chart/PackdrawWagerChart";
import EngagementRewardsChart from "./chart/EngagementRewardsChart";
import GuessBalanceChart from "./chart/GuessBalanceChart";
import DailyUserWagerChart from "./chart/DailyUserWagerChart";
import ShardsChart from "./chart/ShardsChart";
import TopUsersChart from "./chart/TopUsersChart";

const DashBoardLayerOne = () => {

    return (
        <>
            {/* UnitCountOne */}
            <UnitCountOne />

            <section className="row gy-4 mt-1">


                <RegisteredUsersApexChart/>
                <WagerWeightedWagerChart/>
                <PackdrawWagerChart/>
                <GuessBalanceChart/>
                <DailyUserWagerChart/>
                <ShardsChart/>
                <TopUsersChart/>
                <EngagementRewardsChart/>



            </section>
        </>


    )
}

export default DashBoardLayerOne